var map = {
	"./ar-SA.json": [
		"./src/translations/ar-SA.json",
		5
	],
	"./be-BY.json": [
		"./src/translations/be-BY.json",
		6
	],
	"./bg-BG.json": [
		"./src/translations/bg-BG.json",
		7
	],
	"./bn-BD.json": [
		"./src/translations/bn-BD.json",
		8
	],
	"./cs-CZ.json": [
		"./src/translations/cs-CZ.json",
		9
	],
	"./da-DK.json": [
		"./src/translations/da-DK.json",
		10
	],
	"./de-DE.json": [
		"./src/translations/de-DE.json",
		11
	],
	"./el-GR.json": [
		"./src/translations/el-GR.json",
		12
	],
	"./en-GB.json": [
		"./src/translations/en-GB.json",
		13
	],
	"./en-US.json": [
		"./src/translations/en-US.json",
		14
	],
	"./es-ES.json": [
		"./src/translations/es-ES.json",
		15
	],
	"./fi-FI.json": [
		"./src/translations/fi-FI.json",
		16
	],
	"./fr-FR.json": [
		"./src/translations/fr-FR.json",
		17
	],
	"./he-IL.json": [
		"./src/translations/he-IL.json",
		18
	],
	"./hi-IN.json": [
		"./src/translations/hi-IN.json",
		19
	],
	"./hr-HR.json": [
		"./src/translations/hr-HR.json",
		20
	],
	"./hu-HU.json": [
		"./src/translations/hu-HU.json",
		21
	],
	"./id-ID.json": [
		"./src/translations/id-ID.json",
		22
	],
	"./it-IT.json": [
		"./src/translations/it-IT.json",
		23
	],
	"./ja-JP.json": [
		"./src/translations/ja-JP.json",
		24
	],
	"./km-KH.json": [
		"./src/translations/km-KH.json",
		25
	],
	"./ko-KR.json": [
		"./src/translations/ko-KR.json",
		26
	],
	"./me-ME.json": [
		"./src/translations/me-ME.json",
		27
	],
	"./mk-MK.json": [
		"./src/translations/mk-MK.json",
		28
	],
	"./ne-NP.json": [
		"./src/translations/ne-NP.json",
		29
	],
	"./nl-NL.json": [
		"./src/translations/nl-NL.json",
		30
	],
	"./no-NO.json": [
		"./src/translations/no-NO.json",
		31
	],
	"./pl-PL.json": [
		"./src/translations/pl-PL.json",
		32
	],
	"./pt-BR.json": [
		"./src/translations/pt-BR.json",
		33
	],
	"./pt-PT.json": [
		"./src/translations/pt-PT.json",
		34
	],
	"./pt-TL.json": [
		"./src/translations/pt-TL.json",
		35
	],
	"./ro-RO.json": [
		"./src/translations/ro-RO.json",
		36
	],
	"./ru-MD.json": [
		"./src/translations/ru-MD.json",
		37
	],
	"./ru-RU.json": [
		"./src/translations/ru-RU.json",
		38
	],
	"./sh-HR.json": [
		"./src/translations/sh-HR.json",
		39
	],
	"./si-LK.json": [
		"./src/translations/si-LK.json",
		40
	],
	"./sk-SK.json": [
		"./src/translations/sk-SK.json",
		41
	],
	"./sq-AL.json": [
		"./src/translations/sq-AL.json",
		42
	],
	"./sq-MK.json": [
		"./src/translations/sq-MK.json",
		43
	],
	"./sr-CS.json": [
		"./src/translations/sr-CS.json",
		44
	],
	"./sr-ME.json": [
		"./src/translations/sr-ME.json",
		45
	],
	"./sr-RS.json": [
		"./src/translations/sr-RS.json",
		46
	],
	"./sr-SP.json": [
		"./src/translations/sr-SP.json",
		47
	],
	"./src/cboard.json": [
		"./src/translations/src/cboard.json",
		48
	],
	"./sv-SE.json": [
		"./src/translations/sv-SE.json",
		49
	],
	"./tg-TJ.json": [
		"./src/translations/tg-TJ.json",
		50
	],
	"./th-TH.json": [
		"./src/translations/th-TH.json",
		51
	],
	"./tk-TM.json": [
		"./src/translations/tk-TM.json",
		52
	],
	"./tr-TR.json": [
		"./src/translations/tr-TR.json",
		53
	],
	"./tu-TI.json": [
		"./src/translations/tu-TI.json",
		54
	],
	"./uk-UA.json": [
		"./src/translations/uk-UA.json",
		55
	],
	"./ur-PK.json": [
		"./src/translations/ur-PK.json",
		56
	],
	"./vi-VN.json": [
		"./src/translations/vi-VN.json",
		57
	],
	"./zh-CN.json": [
		"./src/translations/zh-CN.json",
		58
	],
	"./zu-ZA.json": [
		"./src/translations/zu-ZA.json",
		59
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/translations lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;